import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import { convertAttendeesToRecipientWellViewStates } from 'owa-calendar-notes-editor/lib/utils/recipientAttendeeConversions';
import { getAllAttendees, getAttendeeLists } from './getAttendees';

export function getRecipientsFromRequiredAttendees(): ReadWriteRecipientViewState[] {
    return convertAttendeesToRecipientWellViewStates(getAttendeeLists()[0]);
}

export function getRecipientsFromOptionalAttendees(): ReadWriteRecipientViewState[] {
    return convertAttendeesToRecipientWellViewStates(getAttendeeLists()[1]);
}

export function getAllRecipientsFromAttendees(): ReadWriteRecipientViewState[] {
    return convertAttendeesToRecipientWellViewStates(getAllAttendees());
}
